"use client"
import { classNames, type VariantProps } from "../../utils"
import { CenterAligned, type CenterAlignedProps } from "../CenterAligned"
import { type AvatarBadgeSize, avatarBadgeVariants } from "./avatar-badge"

export type AvatarBadgeProps = CenterAlignedProps &
  Omit<VariantProps<typeof avatarBadgeVariants>, "tint"> & {
    tintSrc?: string
  }

export const AVATAR_BADGE_DEFAULT_SIZE: AvatarBadgeSize = "md"

const badgeTintClassNames = classNames("absolute inset-0")

export function AvatarBadge({
  children,
  className,
  size = AVATAR_BADGE_DEFAULT_SIZE,
  tintSrc,
  ...rest
}: AvatarBadgeProps) {
  return (
    <CenterAligned
      className={classNames(
        avatarBadgeVariants({ size, tint: Boolean(tintSrc) }),
        className,
      )}
      {...rest}
    >
      {children}
      {tintSrc && (
        <div
          className={classNames(
            badgeTintClassNames,
            "-z-10 overflow-hidden backdrop-blur-0",
          )}
        >
          <img className={badgeTintClassNames} src={tintSrc} />
          <div
            className={classNames(badgeTintClassNames, "bg-additional-3/60")}
          />
          <div className={classNames(badgeTintClassNames, "backdrop-blur")} />
        </div>
      )}
    </CenterAligned>
  )
}
